//This is for the auto-Payments strictly
import React, { useState } from "react";
import "../styles/PhoneNumberInput.css";

function PhoneNumberInput({ amount, onSubmit, onCancel }) {
  const [phone, setPhone] = useState("");

  const handlePay = () => {
    const isValidKenyanNumber = /^(?:07\d{8}|01\d{8})$/;

    if (!isValidKenyanNumber.test(phone)) {
      alert("Please enter a valid 10-digit Safaricom number (07XXXXXXXX or 01XXXXXXXX)");
      return;
    }

    onSubmit(phone);
  };

  const handleChange = (e) => {
    // Only allow digits
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
  };

  return (
    <div className="phone-input-overlay">
      <div className="phone-input-modal">
        <button className="close-btn" onClick={onCancel}>✕</button>
        <h3>Pay KSh {amount}</h3>
        <input
          type="tel"
          placeholder="07XXXXXXXX"
          value={phone}
          onChange={handleChange}
          maxLength={10}
        />
        <button className="pay-btn" onClick={handlePay}>
          Pay Now
        </button>
      </div>
    </div>
  );
}

export default PhoneNumberInput;
